import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'id',
  months: [
    'Januari',
    'Februari',
    'Maret',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Agustus',
    'September',
    'Oktober',
    'November',
    'Desember',
  ],
  monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'],
  weekdays: ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'],
  weekdaysMin: ['Mi', 'Sn', 'Sl', 'Rb', 'Km', 'Ju', 'Sb'],
  weekdaysShort: ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd, D MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd, D MMMM HH:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM YYYY h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'ddd, D MMM YYYY h:mm A',
    'llll-Y': 'ddd, D MMM h:mm A',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'HH.mm ([GMT]Z)',
    'LLL+to': 'D MMMM YYYY HH.mm ([GMT]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { other: '%s thn lalu' },
    M: { other: '%s bln lalu' },
    w: { other: '%s mgg lalu' },
    d: { other: '%s h lalu' },
    h: { other: '%s jam lalu' },
    m: { other: '%s mnt lalu' },
    s: { other: '%s dtk lalu' },
  },
  future: {
    y: { other: 'dlm %s thn' },
    M: { other: 'dlm %s bln' },
    w: { other: 'dlm %s mgg' },
    d: { other: 'dalam %s h' },
    h: { other: 'dalam %s jam' },
    m: { other: 'dlm %s mnt' },
    s: { other: 'dlm %s dtk' },
  },
  abbr: {
    y: { other: '%s thn.' },
    M: { other: '%s bln' },
    w: { other: '%s minggu' },
    d: { other: '%s h' },
    h: { other: '%s j' },
    m: { other: '%s mnt' },
    s: { other: '%s dtk' },
  },
  justNow: 'Baru saja',
  yesterday: 'Kemarin',
  today: 'Hari Ini',
  tomorrow: 'Besok',
  weekStart: 0,
};
const localeName: LocaleName = 'id';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
